
import React from 'react';
import AMCConstants from './AMCConstants';
import ZProps from './zprops';
import AMC from './AMC';
import { ZOO } from './zoo';
import { ROUTER } from './AMCRouter';
import ZNetwork from './znetwork';
import PleaseStandBy from "./PleaseStandBy";
import ZooNoResultsFound from "./ZooNoResultsFound";
import { ZooSearchResultLineItem } from './ZooLeaderboardsPage';
import { ZooSearchResultLineItemStats } from './ZooLeaderboardsPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

export default class ZooSearchPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		let { path } = this.props;
		path = path.replace(AMCConstants.SEARCH_SPECIAL_FOCUS_CHAR, ":");
		if (path.startsWith("uses:")) {
			path = path.replace(/-/g,"/");
		}
		ZProps.set("path", "/search/" + path)
		ZOO.setTitle(path);
		ZNetwork.get("search", path, (err, list) => {
			this.setState({ searchresults: list });
		})
	}
	componentWillUnmount() {
		ZOO.setTitle(null);
	}
	render() {
		let { searchresults } = this.state;
		if (!searchresults) {
			return <PleaseStandBy />;
		}
		let { wtfs, services } = searchresults;

		let status_widget = null;
		let numresults = 0;
		Object.keys(searchresults).forEach( r => { numresults += (searchresults[r].length || 0) } );
		if (numresults === 0) {
			status_widget = <ZooNoResultsFound /> // <div className="ZooSearchPageNoResults">No search results found</div> 
		}

		let definition_widget = null;
		if (wtfs) {
			definition_widget = <div className="ZooSearchPageDefinition"><p>{wtfs[0]}</p></div>
		}
		let parts_widgets = [];
		let kinds = Object.keys(searchresults).filter( kind => { return kind !== "users" && kind !== "wtfs" && kind !== "services" } );
		for (let i = 0; i < kinds.length; ++i) {
			parts_widgets = parts_widgets.concat(searchresults[kinds[i]].filter(x => !!x).map( p => { 
				return (
					<div className="ZooSearchPagePart" key={p.uri}>
						<ZooSearchResultLineItem item={p} description={p.description && p.description.length > 200 ? p.description.substring(0, 197) + "..." : p.description} />
					</div>
				)
			}))
		}
		let service_widgets = (services || []).filter(x => !!x).map( s => { 
			return (
				<a key={s.uri} onClick={ROUTER.pushRoute.bind(ROUTER, "/zoo/" + s.uri)} href={"/zoo/" + s.uri} className="ZooSearchPageService">
					<div className="ZooSearchPageServiceThumb">
						{AMC.getNodeThumbElement(s, "ZooSearchPageServiceThumbImg")}
						<div className="ZooSearchPageServiceThumbPlayButton">
							<img alt="play" src="/images/play.png" />
						</div>
					</div>
					<div className="ZooSearchPageServiceName">{s.name}</div>
					<div className="ZooSearchPageServiceDesc">{s.description}</div>
					<div className="ZooSearchPageServiceStats"><ZooSearchResultLineItemStats item={s} stats={s} included={["stars", "likes", "visits"]} /></div>
				</a>
			)
		});
		if (service_widgets) {
			service_widgets = 
				<div className="ZooSearchPageServices ClearFix">
					{service_widgets}
				</div> 
		}
		let suggestions = 
			<div className="ZooSearchPageServicesSuggestions">
				<a href={"/search/is:service"}>all services</a>
				<a href={"/search/is:trainer"}>all algorithms</a>
				<a href={"/search/is:dataset"}>all datasets</a>
			</div>
		return (
			<div className="ZooSearchPage">
				{status_widget}
				{definition_widget}
				{service_widgets}
				{parts_widgets}
				{suggestions}
			</div>
		)
	}
}
export class ZooSearchPageServiceResult extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { item, removable } = this.props;
			return (
				<a key={item.uri} onClick={ROUTER.pushRoute.bind(ROUTER, "/zoo/" + item.uri)} href={"/zoo/" + item.uri} className="ZooSearchPageService">
					<div className="ZooSearchPageServiceThumb">
						{AMC.getNodeThumbElement(item, "ZooSearchPageServiceThumbImg", true)}
						{ item.kind === "service" ?
							<div className="ZooSearchPageServiceThumbPlayButton">
								<img alt="play" src="/images/play.png" />
							</div>
						: '' }
						{ removable ? <div className="ZooSearchPageServiceResultRemoveButton" onClick={(e) => { removable(item.uri, e) } }><FontAwesomeIcon icon={faTimes} /></div> : '' }
					</div>
					<div className="ZooSearchPageServiceName">{item.name}</div>
					<div className="ZooSearchPageServiceDesc">{item.description}</div>
					<div className="ZooSearchPageServiceStats"><ZooSearchResultLineItemStats item={item} stats={item} included={["stars", "likes", "visits"]} /></div>
				</a>
			)
	}
}



// WEBPACK FOOTER //
// ./src/ZooSearchPage.js